// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-card-product-quick-view-button-button-brhll{align-items:center;background:hsla(0,0%,100%,.95);border:0;border-radius:999px;box-shadow:0 3px 8px 0 rgba(0,0,0,.12);color:#111;cursor:pointer;display:inline-flex;font-size:13px;font-weight:500;grid-gap:6px;gap:6px;padding:8px 14px;white-space:nowrap}.components-products-card-product-quick-view-button-button-brhll:hover{color:var(--color-primary)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "components-products-card-product-quick-view-button-button-brhll"
};
module.exports = ___CSS_LOADER_EXPORT___;
